export const backgroundColorDarkTheme = '#0b1220';
export const fontColorDarkTheme = '#ffffff';
export const borderColorDarkTheme = 'gray';
export const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  backgroundColor: backgroundColorDarkTheme,
  transform: 'translate(-50%, -50%)',
  width: 400,
  maxWidth: '90vw',
  maxHeight: '80vh',
  overflow: 'auto',
  boxShadow: 24,
  p: 4,
  pt: 0,
};
